__turbopack_context__.v({
  "link": "ZgVG8a_link",
});
